import { createApp } from 'vue'
import App from './App.vue'
import '@mdi/font/css/materialdesignicons.css' 

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import 'vue-loading-overlay/dist/css/index.css';

import routes from "./routes"
import store from './store'

import VueGtag from 'vue-gtag'

//firebase push通知
import {initializeApp } from 'firebase/app'
import { getToken,getMessaging,onMessage} from "firebase/messaging"

const vuetify = createVuetify({
  components,
  directives,
  theme:{defaultTheme:'light'},
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
})

const app = createApp(App)

app.use(vuetify);
app.use(store);
app.use(routes);

app.use(VueGtag,{
  config:{
    id:'AW-10896111516'
  }
},routes);

app.mount('#app')

//firebase Push通知

const firebaseConfig = {
  apiKey: "AIzaSyDJqqfPEAuDY2zo2ygq-89AZA1HDDlDoBw",
  authDomain: "gce-test-330407.firebaseapp.com",
  projectId: "gce-test-330407",
  storageBucket: "gce-test-330407.appspot.com",
  messagingSenderId: "173457672514",
  appId: "1:173457672514:web:b5987095e9668766bc60db",
  measurementId: "G-GBMZ48RTFH"
};

const pushApp = initializeApp(firebaseConfig);
const messaging = getMessaging(pushApp);

const saveFcmToken = (token) => {
  console.log("fcm token save")
  let url = './api/api.php';
  let data = {
    func:"fcmToken保存",
    token:token,
  };

  let param = {
      method : "POST",
      headers : { "Content-Type": "application/json" },
      body : JSON.stringify(data),
      }
  fetch(url,param)
  .then(response => {return response.text();})
  .then(result => {
    try {
      const jsonData = JSON.parse(result);
      return jsonData;
    }catch(e){
      return Promise.reject({body:result,type:'unparsable'})
    }
  })
  .then(result => {
    console.log("fcmtoken保存",result)
  })
  .catch(error =>{
    console.log("fcmtokenエラー",error)
  })
  .finally(() =>{
    return
  })
}


//パーミッションのリクエスト

Notification.requestPermission()
.then((permission) => {
  if(permission == 'granted'){
    console.log("permission",permission)
  }else{
    console.log("permission",permission) 
  }

  //OKだったらTokenを取る
  getToken(messaging,{vapidKey:"BD0aTjY1OcUxMaN2vmyxqm_33HzsxNIGins6A8PJ4pFjjnEwoE2j4Kot0EWBFepMx3NDZBuE7zt8zO8TsxpSEr8"})
  .then((currentToken) => {
    if(currentToken){
      saveFcmToken(currentToken)
      console.log("push token ok2",currentToken)
    }else{
      console.log("push token ng")
    }
  })
  .catch((err) => {
    console.log("push token err",err)
  })


})
.catch((err) => {
  console.log("premission_err",err)
})
.finally(() => {

})

onMessage(messaging, (payload) => {
  console.log('foregroundMessage ', payload);
})


/*

pushNotifAccountKey.jsonから送信用のトークンを取る
https://qiita.com/tthogho1/items/de76b222e3ee0f5dd633


curl -X POST -H "Authorization: Bearer {$send_token}" -H Content-Type:"application/json" -d '{"notification":{"title":"test","body":"testbody"},"to":"fUxvUWH2uZN1AZA_fRXvfV:APA91bHLUfoX6E_H34m7A8iwUnctI2wUsStcPhPI6_ypLn0Mi7sPSrsmir4o7_w9Cr7RJOlFg2Wq82-Z6NUKYlE3d8U9kvoqsu-B6xGu5xnu9h4Bqm2xvMRLMTuQzMwJOtABCCixgR7R"}' https://fcm.googleapis.com/v1/projects/gce-test-330407/messages:send

*/